import React, { useState, useEffect, useRef } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { ClasificadorMultas } from "./modalClasificadorMultas";
import axios from "axios";
import { Toasts } from "../toasts";

const TablaClasifiacdorMultas = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accclasemulta = JSON.parse(localStorage.getItem("accclasemulta"));

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          CÓDIGO
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Descripción",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          DESCRIPCIÓN
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          CÓDIGO MULTA
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [claseMulta, setClaseMulta] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idtipomulta.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.codigomulta.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "tipomulta";
    let orden = "idtipomulta";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          txtBuscador.current.focus();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarRegistro = (id) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/multas/multasclasid?id=${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setClaseMulta(response.data);
            setMostrar2(true);
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const gestionarExpendedor = (op, id) => (e) => {
    if (op === 4) {
      if (accclasemulta.substring(0, 1) !== "0") {
        setOperacion(4);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accclasemulta.substring(1, 2) !== "0") {
        setOperacion(op);
        setMostrar2(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accclasemulta.substring(2, 3) !== "0") {
        setOperacion(op);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accclasemulta.substring(3, 4) !== "0") {
        setOperacion(op);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const handleCloseSi = () => {
    setActivate(false);
    SeleccionarRegistro();
    setMostrar4(false);
  };

  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  return (
    <div style={{ backgroundColor: "#", height: "100%", width: "100%" }}>
      <div className="row col-md-12 py-5 px-5">
        <div className="px-5 row">
          <div className="col-md-12 p-2 mt-4">
            <div className="row col-md-12 d-flex justify-content-between">
              <input
                type="text"
                className=" col-3 form-control form-control-sm rounded-pill"
                ref={txtBuscador}
                onChange={handleSearch}
                placeholder="Buscar"
              />
              <div className="col-3 d-flex justify-content-end">
                <button
                  onClick={gestionarExpendedor(1, "")}
                  style={{ marginBottom: "5px" }}
                  className={
                    accclasemulta.substring(1, 2) === "0"
                      ? "btn btn-sm btn-secondary rounded-circle"
                      : "btn btn-sm btn-primary rounded-circle"
                  }
                >
                  <i className="fas fa-plus"></i>{" "}
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-12" style={{ margin: "auto" }}>
            <TblContainer>
              <TblHead />

              <TableBody>
                {records &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <TableRow key={index} style={{ padding: "0" }}>
                      <TableCell style={{ textAlign: "center" }}>
                        {item.idtipomulta}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {item.descripcion}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {item.codigomulta}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "center", alignItems: "center" }}
                      >
                        <button
                          onClick={gestionarExpendedor(4, item.idtipomulta)}
                          style={
                            {
                              /* pointerEvents: accclasemulta.substring(0,1) === '0' ? 'none' : 'cursor' */
                            }
                          }
                          className={
                            accclasemulta.substring(0, 1) === "0"
                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                              : "btn btn-sm mx-1 btn-info rounded-circle"
                          }
                        >
                          <i className="fas fa-eye"></i>{" "}
                        </button>
                        <button
                          onClick={gestionarExpendedor(2, item.idtipomulta)}
                          style={
                            {
                              /* pointerEvents: accclasemulta.substring(2,3) === '0' ? 'none' : 'cursor' */
                            }
                          }
                          className={
                            accclasemulta.substring(2, 3) === "0"
                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                              : "btn btn-sm mx-1 btn-warning rounded-circle"
                          }
                        >
                          <i className="fa fa-edit"></i>{" "}
                        </button>
                        <button
                          onClick={gestionarExpendedor(3, item.idtipomulta)}
                          style={
                            {
                              /* pointerEvents: accclasemulta.substring(3,4) === '0' ? 'none' : 'cursor' */
                            }
                          }
                          className={
                            accclasemulta.substring(3, 4) === "0"
                              ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                              : "btn btn-sm mx-1 btn-danger rounded-circle"
                          }
                        >
                          <i className="fa fa-trash"></i>{" "}
                        </button>
                      </TableCell>
                    </TableRow>
                    //
                  ))}
              </TableBody>
            </TblContainer>
            <TblPagination />
          </div>
        </div>

        <ClasificadorMultas
          show={mostrar2}
          onHideCancela={handleCancela2}
          onHideRenderizar={SeleccionarRegistros}
          claseMulta={claseMulta}
          operacion={operacion}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
      </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
      <Dimmer active={activate} />
    </div>
  );
};
export default TablaClasifiacdorMultas;



// WEBPACK FOOTER //
// ./src/components/multas/tablaClasificadorMultas.js